import { Observable } from 'rxjs';

export interface Target {
  distribuidorId: number;
  categoriaProductoId: number;
  categoriaProductoNombre: string;
  unidadNegocioId: number;
  unidadNegocioNombre: string;
  mesIndex: number;
  objetivoId: number;
  objetivoValor: number;
}
export interface TargetQView {
  distribuidorId: number;
  categoriaProductoId: number;
  categoriaProductoNombre: string;
  unidadNegocioId: number;
  unidadNegocioNombre: string;
  mesIndex: number;
  targetAId: number;
  targetAMesIndex: number;
  targetBId: number;
  targetBMesIndex: number;
  targetCId: number;
  targetCMesIndex: number;
  targetValueA: number;
  targetValueB: number;
  targetValueC: number;
}
export interface QHeaderMonths {
  monthA: string;
  monthB: string;
  monthC: string;
}
export interface QHeader {
  Q1Header: QHeaderMonths;
  Q2Header: QHeaderMonths;
  Q3Header: QHeaderMonths;
  Q4Header: QHeaderMonths;
}
export interface TargetStatus {
  distribuidorId: number;
  estado: number;
  anioFiscal: number;
}

export interface TargetReportDistribuidor {
  anioFiscal: number;
  codigoDistribuidor: string;  
  nombreDistribuidor: string;
  unidadNegocio: string;
  categoria: string;
  usuario_Cadastro: string;
  usuario_Aprovacao: string;    
  octubre: number;
  noviembre: number;
  diciembre: number;
  enero: number;
  febrero: number;
  marzo: number;
  abril: number;
  mayo: number;
  junio: number;
  julio: number;
  agosto: number;
  septiembre: number;
}

export interface TargetReportRelacionesPadresHijos {
  pais: string;
  nombrePerfil: string;
  codigoUsuario: number;
  nome: string;
  email: string;
  codigoDistribuidor: string;
  nombreDistribuidor: string;
  paisDistribuidor: string;
  codigoUsuarioPadre: number;
  nombreUsuarioPadre: string;
}

export abstract class TargetData {
  abstract getList(distributorId: number): Observable<Target[]>;
  abstract getStatus(distributorId: number, anioFiscal: number): Observable<TargetStatus>;
  abstract aproveTarget(distributorId: number, anioFiscal: number): Observable<any>;
  abstract rejectTarget(distributorId: number, anioFiscal: number): Observable<any>;
  abstract saveList(targets: Target[], anioFiscal: number): Observable<any>;
  abstract getHeaderMonths(lang: string, anioFiscal: number): QHeader;
}
